module.exports = __webpack_public_path__ + "static/media/clear-time-period_inactive.b9c1d731.svg";